import { useContext, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { getImage, GatsbyImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'
import { dotPath, isNilOrEmpty } from 'ramdasauce'
import { useForm } from 'react-hook-form'
import cn from 'classnames'

import { useStyles } from './styles'
import { Text } from 'components/atoms'
import { StoreContext } from 'context'

export const CartItem = ({ data }) => {
  const classes = useStyles()

  const [editing, setEditing] = useState(false)

  const {
    removeLineItem,
    updateLineItem,
    store: { client, checkout },
  } = useContext(StoreContext)

  const title = dotPath('mediaData.title', data)
  const cartVariant = dotPath('cartData.variant', data)
  const selectedOptions = dotPath('selectedOptions', cartVariant)
  const quantity = dotPath('cartData.quantity', data)

  const FIELDS = {
    VARIANT: {
      NAME: 'Variant',
    },
    QUANTITY: {
      NAME: 'Quantity',
    },
  }

  const { register, watch, reset } = useForm({
    mode: 'onTouched',
    defaultValues: {
      [FIELDS.QUANTITY.NAME]: dotPath('cartData.quantity', data),
      [FIELDS.VARIANT.NAME]: dotPath('value', selectedOptions[0]),
    },
  })

  const selectedVariant = dotPath('shopifyData.variants', data).find(
    (variant) => variant.title === watch(FIELDS.VARIANT.NAME)
  )

  const handleRemove = () => {
    removeLineItem(client, checkout.id, dotPath('cartData.id', data))
  }
  const handleEdit = () => {
    if (editing) {
      updateLineItem(
        client,
        checkout.id,
        dotPath('cartData.id', data),
        watch(FIELDS.QUANTITY.NAME),
        selectedVariant.storefrontId
      )
    }
    setEditing(!editing)
  }

  useEffect(() => {
    reset({
      [FIELDS.QUANTITY.NAME]: dotPath('cartData.quantity', data),
      [FIELDS.VARIANT.NAME]: dotPath('value', selectedOptions[0]),
    })
  }, [FIELDS.VARIANT.NAME, FIELDS.QUANTITY.NAME, data, selectedOptions, reset])

  // item subtotal if we need this data later
  // const variantPrice = dotPath('price', cartVariant)
  // const itemSubtotal = `$${variantPrice * quantity}.00`

  const editingOptions = (
    <div className={classes.productOptions}>
      {selectedOptions[0].value !== 'Default Title' && (
        <div className={classes.option}>
          <Text tag="p" size="label3" className={classes.optionTitle}>
            {dotPath('name', selectedOptions[0])}
          </Text>
          <div className={cn(classes.editSelect, classes.editField)}>
            <select {...register(FIELDS.VARIANT.NAME)}>
              {dotPath('shopifyData.variants', data).map((variant, i) => {
                return (
                  <option value={dotPath('title', variant)} key={i}>
                    {dotPath('title', variant)}
                  </option>
                )
              })}
            </select>
          </div>
        </div>
      )}
      <div className={classes.option}>
        <Text tag="p" size="label3" className={classes.optionTitle}>
          Quantity
        </Text>
        <input
          {...register(FIELDS.QUANTITY.NAME)}
          type="number"
          min="1"
          max={dotPath('shopifyData.totalInventory', data)}
          className={cn(classes.editField, classes.editInput)}
        ></input>
      </div>
    </div>
  )
  const staticOptions = (
    <div className={classes.productOptions}>
      {selectedOptions[0].value !== 'Default Title' && (
        <div className={classes.option}>
          <Text tag="p" size="label3" className={classes.optionTitle}>
            {dotPath('name', selectedOptions[0])}
          </Text>
          <div className={classes.optionValue}>
            <Text size="label3">{dotPath('value', selectedOptions[0])}</Text>
          </div>
        </div>
      )}
      <div className={classes.option}>
        <Text tag="p" size="label3" className={classes.optionTitle}>
          Quantity
        </Text>
        <div className={classes.optionValue}>
          <Text size="label3">{quantity}</Text>
        </div>
      </div>
    </div>
  )

  return (
    <div className={classes.wrapper}>
      {!isNilOrEmpty(dotPath('mediaData.productImages')) && (
        <Link
          to={`/product/${dotPath('mediaData.urlSlug', data)}`}
          className={classes.imageLink}
        >
          <GatsbyImage
            image={getImage(dotPath('mediaData.productImages', data)[0])}
            alt={title}
            className={classes.image}
          />
        </Link>
      )}

      <div className={classes.productDetails}>
        {!isNilOrEmpty(title) && (
          <Text tag="p" className={classes.title} size="body5">
            {title}
          </Text>
        )}
        {!editing ? staticOptions : editingOptions}
        <div className={classes.productControls}>
          <button className={classes.controlButton} onClick={handleEdit}>
            <Text size="label3" className={classes.control}>
              {editing ? 'Submit' : 'Edit'}
            </Text>
          </button>
          <Text size="label3"> / </Text>
          <button className={classes.controlButton} onClick={handleRemove}>
            <Text size="label3" className={classes.control}>
              Remove
            </Text>
          </button>
        </div>
      </div>

      {/* legacy item subtotal code, leaving this in case we want to add it back */}
      {/* <div className={classes.leftColumn}>
        <button className={classes.deleteButton} onClick={handleRemove}>
          <div className={classes.x} />
        </button>
         <div>
          <Text size="label2">{itemSubtotal}</Text>
        </div>
      </div> */}
    </div>
  )
}

// export const CartItem = React.memo(MemoComponent)

CartItem.propTypes = {
  data: PropTypes.object,
}

CartItem.defaultProps = {
  data: null,
}
